import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { SharedService } from './shared.service';
import { IApiResponse } from './api-response';
import { map, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class HttpserviceService {
  // public serverName="https://dx-admimistration.azurewebsites.net/POSAPI/";
  //  public serverName="https://dx-admimistrationtest.azurewebsites.net/POSAPI/";

  public serverName = environment.apiUrl2;

  token: string = '';
  constructor(private http: HttpClient, public sharedService: SharedService) {
    this.token = sessionStorage.getItem('token') || '';
  }

  login(detail: any) {
    let headers = new HttpHeaders();
    headers = headers.set('Content-Type', 'application/json');
    return this.http.post(this.serverName + 'Login', detail, {
      headers: headers,
    });
  }
  GetLookupsById(id: any) {
    let headers = new HttpHeaders();
    headers = headers.set('Content-Type', 'application/json');
    headers = headers.set('Authorization', this.token);

    return this.http.get(
      this.serverName + 'api/Lookups/GetLookups?lookupTypeId=' + id,
      { headers: headers }
    );
  }
  GetUsers() {
    let headers = new HttpHeaders();
    headers = headers.set('Content-Type', 'application/json');
    headers = headers.set('Authorization', this.token);

    return this.http.get(this.serverName + 'api/User/GetUsers', {
      headers: headers,
    });
  }
  GetBranchesById(id: any, sort: any, Search: any, pageSize: any, pageNo: any) {
    let headers = new HttpHeaders();
    headers = headers.set('Content-Type', 'application/json');
    headers = headers.set(
      'Authorization',
      sessionStorage.getItem('token') || ''
    );
    return this.http.get(
      this.serverName +
      'api/Branches/GetBranches?BranchTypeId=' +
      id +
      '&sort=' +
      sort +
      '&Search=' +
      Search +
      '&PageNo=' +
      pageNo +
      '&PageSize=' +
      pageSize,
      { headers: headers }
    );
  }
  AddBranch(details: any) {
    let headers = new HttpHeaders();
    headers = headers.set('Content-Type', 'application/json');
    headers = headers.set(
      'Authorization',
      sessionStorage.getItem('token') || ''
    );
    return this.http.post(this.serverName + 'api/Branches/AddBranch', details, {
      headers: headers,
    });
  }

  /**
  * Automatically chooses the correct API base
  */
  private resolveBaseUrl(apiBaseUrl?: string): string {
    switch (apiBaseUrl) {
      case 'admin':
        return environment.apiUrl2;
      case 'master':
        return environment.masterBaseUrl;
      case 'cm':
        return environment.cmBaseUrl;
      default:
        return environment.apiUrl;
    }
  }

  /**
   * GET request
   */
  get(api: string, apiBaseUrl?: string): Observable<IApiResponse> {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json; charset=utf-8',
      'Access-Control-Allow-Origin': '*',
      'Access-Control-Expose-Headers': '*',
      'Access-Control-Allow-Methods': 'GET',
      'Access-Control-Allow-Headers': '*',
    });

    const baseUrl = this.resolveBaseUrl(apiBaseUrl);

    return this.http.get<IApiResponse>(baseUrl + api, { headers }).pipe(
      map((response: any) =>
        typeof response === 'string' ? this.JsonParseData(response) : response
      )
    );
  }

  /**
   * POST request
   */
  post(api: string, data: any, apiBaseUrl?: string): Observable<IApiResponse> {
    const headers = new HttpHeaders({
      ...(!(data instanceof FormData) && {
        'Content-Type': 'application/json; charset=utf-8',
      }),
      'Access-Control-Allow-Origin': '*',
      'Access-Control-Expose-Headers': '*',
      'Access-Control-Allow-Methods': 'POST',
      'Access-Control-Allow-Headers': '*',
    });

    const baseUrl = this.resolveBaseUrl(apiBaseUrl);
    const requestData = data instanceof FormData ? data : JSON.stringify(data);

    return this.http.post<IApiResponse>(baseUrl + api, requestData, { headers }).pipe(
      map((response) =>
        typeof response === 'string' ? this.JsonParseData(response) : response
      )
    );
  }

  public JsonParseData(data: any) {
    let result = data;
    try {
      result = JSON.parse(data);
    } catch (e) {
      console.log('[HttpService] JSON parse failed:', e);
    }
    return result;
  }
}
